import { render } from "./match.vue?vue&type=template&id=330c5ff6&scoped=true"
import script from "./match.vue?vue&type=script&lang=js"
export * from "./match.vue?vue&type=script&lang=js"

import "./match.vue?vue&type=style&index=0&id=330c5ff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330c5ff6"]])

export default __exports__